<template>
    <BreadCrumb PageTitle="Modifier les informations de l'Etape 3 du Besc" />
    <EditAddBescStep3/>
</template>

<script lang="ts">

import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditAddBescStep3 from "../../components/BESC/EditBesc/EditAddBescStep3.vue";

export default defineComponent({
    name: "EditAddBescStep3Page",
    components: {
        BreadCrumb,
        EditAddBescStep3
    },
});
</script>